/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationStatus } from './OrganizationStatus';
import {
    OrganizationStatusFromJSON,
    OrganizationStatusFromJSONTyped,
    OrganizationStatusToJSON,
} from './OrganizationStatus';

/**
 * 
 * @export
 * @interface OrgDto
 */
export interface OrgDto {
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof OrgDto
     */
    id?: string;
    /**
     * Brand Id for organization branding. Several orgs can share one brand.
     * @type {string}
     * @memberof OrgDto
     */
    brandId?: string;
    /**
     * Name of an org
     * @type {string}
     * @memberof OrgDto
     */
    name?: string;
    /**
     * Org emails domain
     * @type {string}
     * @memberof OrgDto
     */
    domain?: string;
    /**
     * Org lei
     * @type {string}
     * @memberof OrgDto
     */
    lei?: string;
    /**
     * 
     * @type {OrganizationStatus}
     * @memberof OrgDto
     */
    status?: OrganizationStatus;
    /**
     * User Id
     * @type {string}
     * @memberof OrgDto
     */
    createdByUser?: string;
    /**
     * Date when the instance was created
     * @type {string}
     * @memberof OrgDto
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgDto
     * @deprecated
     */
    orgType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrgDto
     */
    publicRecordLinks?: Array<string>;
}

/**
 * Check if a given object implements the OrgDto interface.
 */
export function instanceOfOrgDto(value: object): boolean {
    return true;
}

export function OrgDtoFromJSON(json: any): OrgDto {
    return OrgDtoFromJSONTyped(json, false);
}

export function OrgDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'name': json['name'] == null ? undefined : json['name'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'lei': json['lei'] == null ? undefined : json['lei'],
        'status': json['status'] == null ? undefined : OrganizationStatusFromJSON(json['status']),
        'createdByUser': json['createdByUser'] == null ? undefined : json['createdByUser'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'orgType': json['orgType'] == null ? undefined : json['orgType'],
        'publicRecordLinks': json['publicRecordLinks'] == null ? undefined : json['publicRecordLinks'],
    };
}

export function OrgDtoToJSON(value?: OrgDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'brandId': value['brandId'],
        'name': value['name'],
        'domain': value['domain'],
        'lei': value['lei'],
        'status': OrganizationStatusToJSON(value['status']),
        'createdByUser': value['createdByUser'],
        'createdAt': value['createdAt'],
        'orgType': value['orgType'],
        'publicRecordLinks': value['publicRecordLinks'],
    };
}

